import {getCookie} from "@common/utils";

const state = {
    isAgreement: eval(getCookie('isAgreement')),
    alertPromiseShow:false,
}

const mutations = {
    SET_IsAgreement: (state, isAgreement) => {
        state.isAgreement = isAgreement
    },
    SET_alertPromiseShow:(state, alertPromiseShow)=>{
        state.alertPromiseShow = alertPromiseShow
    }
}

const actions = {

}



  const promiseAlert={
    namespaced: true,
    state,
    mutations,
    actions,
}
export default promiseAlert



// WEBPACK FOOTER //
// ./src/match/store/promiseAlert.js